import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Bg from "../../images/bg/hero-bg02.jpg";
import heroImg from "../../images/hero/hero-img02.png";
import heroImg2 from "../../images/hero/hero-img03.png";
import heroImg3 from "../../images/hero/hero-img04.png";
import androidImg from "../../images/Truslypay_imgs/android.png";
import iosImg from "../../images/Truslypay_imgs/apple.png";
import MalyasiaCalculator from "../Calculator/MalyasiaCalculator";

const MalyasiaHero = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section
      className="hero o-hidden hero-style-two pos-rel pt-120 bg_img"
      style={{ backgroundImage: `url(${Bg})` }}
    >
      <div className="container">
        <div className="hero_wrap pt-40">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="xb-hero">
                <Fade
                                 direction="up"
                                 triggerOnce={"false"}
                                 duration={1000}
                                 delay={9}
                               >
                                 <div>
                                   <h1
                                     className="xb-item--title wow fadeInUp country-name-hero-lineofheight"
                                     data-wow-duration="600ms"
                                   >
                                     Send Money To
                                     <br /> <span className="country-name-hero" >MALYASIA</span>
                                   </h1>
                                 </div>
                               </Fade>
               
                               <Fade
                                 direction="up"
                                 triggerOnce={"false"}
                                 duration={1400}
                                 delay={9}
                               >
                                 <div>
                                   <ul
                                     className="xb-item--item list-unstyled wow fadeInUp"
                                     data-wow-delay="200ms"
                                     data-wow-duration="600ms"
                                   >
                                     <li>
                                       <i className="far fa-check"></i> Global Payments
                                     </li>
                                     <li>
                                       <i className="far fa-check"></i> Safe and Secure
                                     </li>
                                     <li>
                                       <i className="far fa-check"></i> Competitive Rates
                                     </li>
                                     
                                   </ul>
                                 </div>
                               </Fade>
                <Fade
                  direction="up"
                  triggerOnce={"false"}
                  duration={1600}
                  delay={9}
                >
                  <div className=" mt-50">
                    <div
                      className="mt-4 wow fadeInUp"
                      data-wow-delay="300ms"
                      data-wow-duration="600ms"
                    >
                      <a
                        href="https://play.google.com/store/apps/details?id=com.org.tigris"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={ClickHandler}
                        className=""
                      >
                        <img
                          className="download-app-playstore-apple mr-5"
                          
                          src={androidImg}
                          alt="Android App"
                        />
                      </a>

                      <a
                        href="https://apps.apple.com/us/app/tigrispay/id6754586181"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={ClickHandler}
                        className=" "
                      >
                        <img
                          className="download-app-playstore-apple ml-5"
                         
                          src={iosImg}
                          alt="iOS App"
                        />
                      </a>
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="col-lg-5 mt-5 mt-lg-0">
              <MalyasiaCalculator/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MalyasiaHero;
